import Login from '@/pages/Login';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
  // Attribution code from a QR/marketing link (?ref=). Recorded at signup.
  ref: z.string().optional(),
  // Facebook click id from an ad link (?fbclid=). Forwarded to /signup /
  // carried through OAuth; recorded at signup into user_signup_params.
  fbclid: z.string().optional(),
  // Carried by the signup→login bounce when the email turned out to already
  // have an account: prefills the email field so nothing is retyped.
  email: z.string().optional(),
  // The account's sign-in method (google/facebook/azure/password), fetched at
  // the moment signup discovered the collision. Drives the "this email signs
  // in with X" notice + highlighted button. Untrusted input — Login validates
  // it against the known set before using it.
  hint: z.string().optional(),
});

export const Route = createFileRoute('/login')({
  component: Login,
  validateSearch: loginSearchSchema,
});
